var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 88,
    viewBox: "0 0 77 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 88C68.3815 88 77 79.3815 77 68.75C77 58.1185 68.3815 49.5 57.75 49.5C47.1185 49.5 38.5 58.1185 38.5 68.75C38.5 79.3815 47.1185 88 57.75 88ZM66.9831 63.2899L59.6392 75.5298C58.2585 77.8309 55.0828 78.2219 53.1852 76.3243L48.9305 72.0695C47.8565 70.9956 47.8565 69.2544 48.9305 68.1805C50.0044 67.1065 51.7456 67.1065 52.8195 68.1805L55.829 71.1899L62.2669 60.4601C63.0483 59.1578 64.7375 58.7355 66.0399 59.5169C67.3422 60.2983 67.7645 61.9875 66.9831 63.2899Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C0 2.46243 2.46243 0 5.5 0H60.5C63.5376 0 66 2.46243 66 5.5V41.25C66 42.7688 64.7688 44 63.25 44C61.7312 44 60.5 42.7688 60.5 41.25V5.5H5.5V82.5H22V68.75C22 67.2312 23.2312 66 24.75 66H33V88H5.5C2.46243 88 0 85.5376 0 82.5V5.5Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11C12.2312 11 11 12.2312 11 13.75V19.25C11 20.7688 12.2312 22 13.75 22H19.25C20.7688 22 22 20.7688 22 19.25V13.75C22 12.2312 20.7688 11 19.25 11H13.75Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 11C28.7312 11 27.5 12.2312 27.5 13.75V19.25C27.5 20.7688 28.7312 22 30.25 22H35.75C37.2688 22 38.5 20.7688 38.5 19.25V13.75C38.5 12.2312 37.2688 11 35.75 11H30.25Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 11C45.2312 11 44 12.2312 44 13.75V19.25C44 20.7688 45.2312 22 46.75 22H52.25C53.7688 22 55 20.7688 55 19.25V13.75C55 12.2312 53.7688 11 52.25 11H46.75Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.5C12.2312 27.5 11 28.7312 11 30.25V35.75C11 37.2688 12.2312 38.5 13.75 38.5H19.25C20.7688 38.5 22 37.2688 22 35.75V30.25C22 28.7312 20.7688 27.5 19.25 27.5H13.75Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 27.5C28.7312 27.5 27.5 28.7312 27.5 30.25V35.75C27.5 37.2688 28.7312 38.5 30.25 38.5H35.75C37.2688 38.5 38.5 37.2688 38.5 35.75V30.25C38.5 28.7312 37.2688 27.5 35.75 27.5H30.25Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 27.5C45.2312 27.5 44 28.7312 44 30.25V35.75C44 37.2688 45.2312 38.5 46.75 38.5H52.25C53.7688 38.5 55 37.2688 55 35.75V30.25C55 28.7312 53.7688 27.5 52.25 27.5H46.75Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 44C12.2312 44 11 45.2312 11 46.75V52.25C11 53.7688 12.2312 55 13.75 55H19.25C20.7688 55 22 53.7688 22 52.25V46.75C22 45.2312 20.7688 44 19.25 44H13.75Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 44C28.7312 44 27.5 45.2312 27.5 46.75V52.25C27.5 53.7688 28.7312 55 30.25 55H35.75C37.2688 55 38.5 53.7688 38.5 52.25V46.75C38.5 45.2312 37.2688 44 35.75 44H30.25Z",
    fill: "#E7E4E8",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomPic);
export default __webpack_public_path__ + "static/media/room-pic.5f820bd6b877444187ef193a0a581455.svg";
export { ForwardRef as ReactComponent };